/** @jsx h */
import { h } from "hyperapp";
import classNames from "classnames";
import { WrappedSvg } from "../../../utilities/hyperapp";

import downArrowIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../../../button/down-arrow.svg";
import menuIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../../../masthead/menu.svg";

export default function TrackComponent({
  title,
  subtitle,
  image,
  remove,
  play,
  playerItemID,
  playFromHere,
  queueNext,
  actionsActive,
  setActiveTrackActionsEl,
  showActions,
  hideActions,
  isSharedMoment,
  canonicalPath,
  status
}) {
  return (
    <div
      class={classNames({
        "d-flex": true,
        "flex-items-v-center": true,
        "player-queue-track": true
      })}
    >
      <button
        class="player-queue-track__details d-flex flex-items-v-center flex-1 t-left"
        onclick={play}
        ga-on="click,auxclick,contextmenu"
        ga-event-category="audio"
        ga-event-action={status === "playing" ? "pause" : "play"}
        ga-event-label={title}
      >
        {image ? (
          <img class="player-queue-track__image" alt="" src={image.path} />
        ) : (
          <div class={`player-queue-track__image-proxy bg-light-green`} />
        )}
        <div class="player-queue-track__text flex-1">
          {isSharedMoment ? (
            <div class="player-queue-track__shared-moment">
              Shared moment from
            </div>
          ) : null}
          <div class="player-queue-track__title">{title}</div>
          <div class="player-queue-track__subtitle">{subtitle}</div>
        </div>
      </button>
      <TrackActions
        active={actionsActive}
        remove={remove}
        playFromHere={playFromHere}
        queueNext={queueNext}
        setActiveTrackActionsEl={setActiveTrackActionsEl}
        showActions={showActions}
        hideActions={hideActions}
        title={title}
        status={status}
        playerItemID={playerItemID}
        canonicalPath={canonicalPath}
        isSharedMoment={isSharedMoment}
      />
      <div class="player-queue-track__handle">
        <button
          class="player-queue-track__handle-cover"
          data-drag-handle="true"
          title="Drag to reorder"
          aria-label="Drag to reorder"
        />
        <WrappedSvg data={menuIcon} />
      </div>
    </div>
  );
}

function TrackActions({
  remove,
  playFromHere,
  queueNext,
  active,
  setActiveTrackActionsEl,
  showActions,
  hideActions,
  title,
  status,
  canonicalPath,
  isSharedMoment,
  playerItemID
}) {
  return (
    <div
      class="dropdown t-left"
      onupdate={el => {
        if (active) {
          setActiveTrackActionsEl(el);
        }
      }}
    >
      <button
        class="player-queue-track__actions-button"
        onclick={e => {
          e.stopPropagation();
          e.preventDefault();
          if (active) {
            hideActions();
          } else {
            showActions();
          }
        }}
      >
        <span class="hide-visually">Show actions for track</span>
        <span class="player-queue-track__actions-icon">
          <WrappedSvg data={downArrowIcon} />
        </span>
      </button>
      {active ? (
        <div class="dropdown__content dropdown__content--active dropdown__content--right-aligned">
          <ul class="dropdown__list t-alternate">
            <li class="dropdown__item">
              <button
                onclick={e => {
                  e.preventDefault();
                  hideActions();
                  playFromHere();
                }}
                ga-on="click,auxclick,contextmenu"
                ga-event-category="audio"
                ga-event-action={status === "playing" ? "pause" : "play"}
                ga-event-label={title}
                class="dropdown__anchor t-left"
              >
                Play from here
              </button>
            </li>
            <li class="dropdown__item">
              <button
                onclick={e => {
                  e.preventDefault();
                  hideActions();
                  queueNext();
                }}
                class="dropdown__anchor t-left"
                ga-on="click,auxclick,contextmenu"
                ga-event-category="audio"
                ga-event-action="play next"
                ga-event-label={title}
              >
                Play next
              </button>
            </li>
            <li class="dropdown__item">
              <button
                onclick={e => {
                  e.preventDefault();
                  hideActions();
                  remove();
                }}
                class="dropdown__anchor t-left"
                ga-on="click,auxclick,contextmenu"
                ga-event-category="audio"
                ga-event-action="remove"
                ga-event-label={title}
              >
                Remove
              </button>
            </li>
            {isSharedMoment && (
              <li class="dropdown__item">
                <a href={canonicalPath} class="dropdown__anchor t-left">
                  View item
                </a>
              </li>
            )}
            <li class="dropdown__item">
              <a
                href={`/player-items/go/${playerItemID}`}
                class="dropdown__anchor t-left"
              >
                View {isSharedMoment ? " original " : " "} item
              </a>
            </li>
          </ul>
        </div>
      ) : null}
    </div>
  );
}
